import { Box, Flex, Text } from "@chakra-ui/react";
import { ReactNode } from "react";
import { crm } from "../../../theme";

/** Card de seção da tela de processo: ícone em círculo suave + título + subtítulo + ações à direita. */
const SectionCard = ({
  icon,
  title,
  subtitle,
  actions,
  children,
}: {
  icon: ReactNode;
  title: string;
  subtitle?: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
}) => (
  <Box
    bg={crm.surface}
    border={`1px solid ${crm.border}`}
    borderRadius={crm.radius}
    boxShadow={crm.shadowSm}
    mt="24px"
    overflow="hidden"
  >
    <Flex
      align={{ base: "flex-start", md: "center" }}
      justify="space-between"
      gap="12px"
      wrap="wrap"
      px={{ base: "16px", md: "24px" }}
      py="16px"
      borderBottom={`1px solid ${crm.border}`}
    >
      <Flex align="center" gap="12px" minW={0}>
        <Flex
          w="40px"
          h="40px"
          flexShrink={0}
          borderRadius="full"
          bg={crm.brandSoft}
          color={crm.brand}
          align="center"
          justify="center"
          fontSize="18px"
        >
          {icon}
        </Flex>
        <Box minW={0}>
          <Text fontSize="16px" fontWeight="700" color={crm.text} lineHeight="1.3">
            {title}
          </Text>
          {subtitle && (
            <Text fontSize="12px" color={crm.textMuted} mt="2px">
              {subtitle}
            </Text>
          )}
        </Box>
      </Flex>
      {actions && (
        <Flex align="center" gap="8px" wrap="wrap">
          {actions}
        </Flex>
      )}
    </Flex>
    <Box px={{ base: "16px", md: "24px" }} py="20px">
      {children}
    </Box>
  </Box>
);

export default SectionCard;
